import React, { Component } from 'react';
import { Route } from 'react-router-dom';

import EditDocumentPage from '../pages/documents/EditDocumentPage';
import ShowDocumentPage from '../pages/documents/ShowDocumentPage';

import DocumentsPage from '../pages/documents/DocumentsPage';
import OperatedDocumentsPage from '../pages/documents/OperatedDocumentsPage';
import CCDocumentsPage from '../pages/documents/CCDocumentsPage';
import DraftDocumentsPage from '../pages/documents/DraftDocumentsPage';
import SendAllDocumentsPage from '../pages/documents/SendAllDocumentsPage';
import ReceiveAllDocumentsPage from '../pages/documents/ReceiveAllDocumentsPage';
import ExternalReceiveDocumentPage from '../pages/documents/ExternalReceiveDocumentPage';
import InternalReceiveDocumentPage from '../pages/documents/InternalReceiveDocumentPage';
import OrderDocumentsPage from '../pages/documents/OrderDocumentsPage';
import SearchDocumentsPage from '../pages/documents/SearchDocumentsPage';
import CancelDocumentsPage from '../pages/documents/CancelDocumentsPage';

import FullHistoryPage from '../pages/FullHistoryPage';

import OrganizationPage from '../pages/OrganizationPage';
import StoragesPage from '../pages/StoragesPage';
import ManualsPage from '../pages/ManualsPage';

import ReceiveDocumentPage from '../pages/reports/ReceiveDocumentPage';
import AwareReportPage from '../pages/reports/AwareReportPage';
import InternalReportPage from '../pages/reports/InternalReportPage';
import ExternalReportPage from '../pages/reports/ExternalReportPage';
import SystemUsageReportPage from '../pages/reports/SystemUsageReportPage';
import SystemUsageStatisticReportPage from '../pages/reports/SystemUsageStatisticReportPage';
import UsageReportPage from '../pages/reports/UsageReportPage';

import DocumentSettingPage from '../pages/DocumentSettingPage';

import SetupPage from '../pages/settings/SetupPage';
import SettingPage from '../pages/settings/SettingPage';
import ActingsSettingPage from '../pages/settings/ActingsSettingPage';
import SettingSignaturePage from '../pages/settings/SettingSignaturePage';
import SettingFooterPage from '../pages/settings/SettingFooterPage';
import WorkflowsSettingPage from '../pages/settings/WorkflowsSettingPage';
import WorkflowEditPage from '../pages/settings/WorkflowEditPage';
import WorkflowMigrationPage from '../pages/settings/WorkflowMigrationPage';
import CampusPage from '../pages/settings/CampusPage';
import NoticePage from '../pages/settings/NoticePage';

import BusinessUnitPage from '../pages/manage_users/BusinessUnitPage';
import UserPage from '../pages/manage_users/UserPage';
import RoleTemplatePage from '../pages/manage_users/RoleTemplatePage';
import SettingUserPage from '../pages/manage_users/SettingUserPage';

import DocumentTemplatePage from '../pages/templates/DocumentTemplatePage';
import TemplatePage from '../pages/templates/TemplatePage';
import FrontPage from '../pages/templates/FrontPage';

import DepartmentGroupsSettingPage from '../pages/department_groups_settings/DepartmentGroupsSettingPage';
import InformeesSettingPage from '../pages/department_groups_settings/InformeesSettingPage';
import InformGroupsSettingPage from '../pages/department_groups_settings/InformGroupsSettingPage';

import LoginPage from '../pages/LoginPage';
import EditProfilePage from '../pages/EditProfilePage';
import PingCampusPage from '../pages/PingCampusPage';

class Main extends Component {
  render(){
    return(
      <main>
        <Route exact path={`${process.env.PUBLIC_URL}/`} component={DocumentsPage} />
        <Route path={`${process.env.PUBLIC_URL}/login`} component={LoginPage} />
        <Route path={`${process.env.PUBLIC_URL}/edit_profile`} component={EditProfilePage} />

        <Route path={`${process.env.PUBLIC_URL}/documents/mydoc`} component={DocumentsPage} />
        <Route path={`${process.env.PUBLIC_URL}/documents/operated`} component={OperatedDocumentsPage} />
        <Route path={`${process.env.PUBLIC_URL}/documents/cc_box`} component={CCDocumentsPage} />
        <Route path={`${process.env.PUBLIC_URL}/documents/draft`} component={DraftDocumentsPage} />
        <Route path={`${process.env.PUBLIC_URL}/documents/send_all`} component={SendAllDocumentsPage} />
        <Route path={`${process.env.PUBLIC_URL}/documents/receive_all`} component={ReceiveAllDocumentsPage} />
        <Route path={`${process.env.PUBLIC_URL}/documents/external_receive`} component={ExternalReceiveDocumentPage} />
        <Route path={`${process.env.PUBLIC_URL}/documents/internal_receive`} component={InternalReceiveDocumentPage} />
        <Route path={`${process.env.PUBLIC_URL}/documents/order`} component={OrderDocumentsPage} />
        <Route path={`${process.env.PUBLIC_URL}/documents/search`} component={SearchDocumentsPage} />
        <Route path={`${process.env.PUBLIC_URL}/documents/cancel`} component={CancelDocumentsPage} />

        <Route exact path={`${process.env.PUBLIC_URL}/templates`} component={DocumentTemplatePage} />

        <Route path={`${process.env.PUBLIC_URL}/templates/:id/new`} render={({match}) => (
          <TemplatePage params={match.params} />
        )} />

        <Route exact path={`${process.env.PUBLIC_URL}/frontpage/:parent_id/new`} render={({match}) => (
          <FrontPage params={match.params} />
        )} />

        <Route exact path={`${process.env.PUBLIC_URL}/frontpage/:document_id/edit`} render={({match}) => (
          <FrontPage params={match.params} />
        )} />

        <Route path={`${process.env.PUBLIC_URL}/templates/documents/:id/edit/:template_id`} render={({match}) => (
          <EditDocumentPage params={match.params} />
        )} />
        
        <Route path={`${process.env.PUBLIC_URL}/templates/documents/:id/show/:template_id/wp/:workflow_process_id`} component={ShowDocumentPage} />

        <Route path={`${process.env.PUBLIC_URL}/full_history/:workflow_process_id`} component={FullHistoryPage} />

        <Route path={`${process.env.PUBLIC_URL}/organizations`} component={OrganizationPage} />
        <Route path={`${process.env.PUBLIC_URL}/storages`} component={StoragesPage} />
        <Route path={`${process.env.PUBLIC_URL}/manuals`} component={ManualsPage} />
        
        <Route exact path={`${process.env.PUBLIC_URL}/reports/receive`} component={ReceiveDocumentPage} />
        <Route exact path={`${process.env.PUBLIC_URL}/reports/aware`} component={AwareReportPage} />
        <Route exact path={`${process.env.PUBLIC_URL}/reports/internal`} component={InternalReportPage} />
        <Route exact path={`${process.env.PUBLIC_URL}/reports/external`} component={ExternalReportPage} />
        <Route exact path={`${process.env.PUBLIC_URL}/reports/system_usage`} component={SystemUsageReportPage} />
        <Route exact path={`${process.env.PUBLIC_URL}/reports/system_usage_statistic`} component={SystemUsageStatisticReportPage} />
        <Route exact path={`${process.env.PUBLIC_URL}/reports/usage_report`} component={UsageReportPage} />

        <Route path={`${process.env.PUBLIC_URL}/document_setting`} component={DocumentSettingPage} />

        <Route path={`${process.env.PUBLIC_URL}/settings/setup`} component={SetupPage} />
        <Route path={`${process.env.PUBLIC_URL}/settings/sitesetting`} component={SettingPage} />
        <Route path={`${process.env.PUBLIC_URL}/settings/actings`} component={ActingsSettingPage} />
        <Route path={`${process.env.PUBLIC_URL}/settings/signature`} component={SettingSignaturePage} />
        <Route path={`${process.env.PUBLIC_URL}/settings/footer`} component={SettingFooterPage} />
        <Route exact path={`${process.env.PUBLIC_URL}/settings/workflows`} component={WorkflowsSettingPage} />
        <Route path={`${process.env.PUBLIC_URL}/settings/workflows/:id/edit`} render={({match}) => (
          <WorkflowEditPage params={match.params} />
        )} />
        <Route path={`${process.env.PUBLIC_URL}/settings/workflow_migration`} component={WorkflowMigrationPage} />
        <Route path={`${process.env.PUBLIC_URL}/settings/campuses`} component={CampusPage} />
        <Route path={`${process.env.PUBLIC_URL}/settings/notices`} component={NoticePage} />

        <Route path={`${process.env.PUBLIC_URL}/manage_users/businesses`} component={BusinessUnitPage} />
        <Route path={`${process.env.PUBLIC_URL}/manage_users/users`} component={UserPage} />
        <Route path={`${process.env.PUBLIC_URL}/manage_users/roles`} component={RoleTemplatePage} />
        <Route path={`${process.env.PUBLIC_URL}/manage_users/settings`} component={SettingUserPage} />

        <Route path={`${process.env.PUBLIC_URL}/department_groups_settings/department_groups`} component={DepartmentGroupsSettingPage} />
        <Route path={`${process.env.PUBLIC_URL}/department_groups_settings/informees`} component={InformeesSettingPage} />
        <Route path={`${process.env.PUBLIC_URL}/department_groups_settings/inform_groups`} component={InformGroupsSettingPage} />
        <Route path={`${process.env.PUBLIC_URL}/ping`} component={PingCampusPage} />
      </main>
    )
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/layouts/Main.js